import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AdminCustomersPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('navigation.customers')}
      </Typography>
      <Typography variant="body1">
        Customer management and verification interface will be implemented here.
      </Typography>
    </Box>
  );
};

export default AdminCustomersPage;